// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"8ba70171","334":"7a716ab1"}[chunkId] + ".chunk.css";
};